// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2M1JI","dragIcon":"SortableItem_dragIcon__1QeE7","disabled":"SortableItem_disabled__3qW3a"};